import { CSSProperties, ReactNode, useMemo } from 'react'
import { Tooltip as ReactTooltip, ITooltip } from 'react-tooltip'
import { v4 as uuidv4 } from 'uuid'

import { baseTheme } from 'primsell-shared-layer/styles/theme'

import 'react-tooltip/dist/react-tooltip.css'

export enum TooltipVariantE {
  DEFAULT,
  GREEN,
}
export interface TooltipProps extends ITooltip {
  className?: string
  style?: CSSProperties
  tooltipStyle?: CSSProperties
  children?: ReactNode
  tooltipChildren?: ReactNode
  styleVariant?: TooltipVariantE
  disabled?: boolean
}

const TOOLTIP_VARIANT: Record<TooltipVariantE, CSSProperties> = {
  [TooltipVariantE.DEFAULT]: {
    backgroundColor: baseTheme.colors.buttonGrey,
  },
  [TooltipVariantE.GREEN]: {
    backgroundColor: baseTheme.colors.green100,
  },
}

export const Tooltip = ({
  children,
  place = 'bottom',
  styleVariant = TooltipVariantE.DEFAULT,
  className,
  style,
  tooltipStyle,
  disabled = false,
  tooltipChildren,
  ...props
}: TooltipProps) => {
  const dataTooltipId = useMemo(() => uuidv4(), [])

  return (
    <>
      <div id={dataTooltipId} className={className} style={{ ...style }}>
        {children}
      </div>
      {!disabled && (
        <ReactTooltip
          anchorId={dataTooltipId}
          {...props}
          place={place}
          noArrow
          opacity={1}
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '12px',
            padding: '4px 8px',
            borderRadius: '4px',
            zIndex: 1,
            cursor: 'pointer',
            ...TOOLTIP_VARIANT[styleVariant],
            ...tooltipStyle,
          }}
        >
          {tooltipChildren}
        </ReactTooltip>
      )}
    </>
  )
}
